import React, { useState, useRef } from 'react'
import { makeStyles, Box, Typography, IconButton, useTheme, useMediaQuery } from '@material-ui/core'
import { clsx } from 'clsx'
import image_1 from "../images/image_1.png"
import playButton from "../images/playButton.png"
import { useHistory } from 'react-router-dom'
import { ContainedButton } from '../components/buttons/Buttons'

const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: "52px",
        fontWeight: 400,
        lineHeight: "100%",
        textAlign: "left",
        [theme.breakpoints.down('sm')]: {
            fontSize: '36px',
            lineHeight: '100%',
        },
    },
    sectionText: {
        fontSize: '18px',
        color: '#ffffff',
        lineHeight: "140%",
        fontWeight: 200,
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            lineHeight: '24px',
        }
    },
    featuresSection: {
        maxWidth: 1314,
        margin: "0 auto",
        padding: "60px 24px",
        textAlign: "center",
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            padding: "36px 21px",
        },
    },
    lifestyleTitle: {
        marginBottom: 16,
        textAlign: "center"
    },
    lifestyleSubtitle: {
        marginBottom: theme.spacing(6),
        maxWidth: 972,
        margin: '0 auto',
    },
    videoContainer: {
        position: 'relative',
        margin: '0 auto',
        marginBottom: "48px",
        aspectRatio: '16/10',
        width: '100%',
        maxHeight: 567,
        borderRadius: '8px',
        overflow: 'hidden',
    },
    videoImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    playButton: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 50,
        height: 50,
        zIndex: 1,
        transition: "all 0.3s ease",
        '&:hover': {
            transform: 'translate(-50%, -50%) scale(1.1)'
        },
    },
    requestAccessButton: {
        fontSize: '20px',
        fontWeight: 400,
        borderRadius: '5px',
        [theme.breakpoints.down('sm')]: {
            width: '100% !important',
            fontWeight: 500,
        }
    },
}))

export const LifestyleSection: React.FC = () => {
    const classes = useStyles()
    const theme = useTheme()
    const history = useHistory()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const togglePlay = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    }

    const handleInitialPlay = () => {
        setIsPlaying(true);
        if (videoRef.current) {
            videoRef.current.play();
        }
    }

    return (
        <Box className={classes.featuresSection}>
            <Typography variant="h2" className={clsx(classes.sectionTitle, classes.lifestyleTitle)}>
                Unlock The Vault.
            </Typography>
            <Typography className={clsx(classes.sectionText, classes.lifestyleSubtitle)}>
                Discover exclusive Pay-Per-View content, private feeds, and bespoke video requests that you won't find anywhere else on the internet. Behind the velvet rope, our creators offer their most premium content directly to verified members.
            </Typography>
            <Box className={classes.videoContainer}>
                <Box
                    style={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 2,
                        opacity: isPlaying ? 0 : 1,
                        pointerEvents: isPlaying ? 'none' : 'auto',
                        transition: 'opacity 0.5s ease',
                    }}
                >
                    <img
                        src={image_1}
                        alt="Lifestyle preview"
                        className={classes.videoImage}
                    />
                    <IconButton className={classes.playButton} onClick={handleInitialPlay}>
                        <img src={playButton} alt="play video" />
                    </IconButton>
                </Box>

                <video
                    className={classes.videoImage}
                    style={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 1,
                        cursor: 'pointer',
                        opacity: isPlaying ? 1 : 0,
                        transition: 'opacity 0.5s ease',
                    }}
                    ref={videoRef}
                    onClick={togglePlay}
                >
                    <source src="https://files.catbox.moe/folb3k.mp4" type="video/mp4" />
                </video>
            </Box>
            <ContainedButton
                text={isMobile ? "Apply for genesis status" : "Secure Early Access"}
                styles={classes.requestAccessButton}
                onClick={() => history.push(isMobile ? '/apply-as-creator' : '/member-onboarding-step')}
            />
        </Box>
    )
}
